import { PUBLIC_SUFFIXES } from './publicSuffixes';
  export function getRootDomain(hostname: string): string {
    const parts = hostname.split('.').filter(Boolean);
  
    if (parts.length < 2) {
      return hostname; // e.g. localhost or invalid host
    }
  
    const lastTwo = parts.slice(-2).join('.');
    const lastThree = parts.slice(-3).join('.');
  
    if (PUBLIC_SUFFIXES.has(lastTwo) && parts.length >= 3) {
      return `.${lastThree}`; // e.g. www.hawesandcurtis.co.uk → .hawesandcurtis.co.uk
    }
  
    return `.${lastTwo}`; // e.g. www.example.com → .example.com
  }
